var _rect, _rect2, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGymPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#E48D35"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "url(#paint0_linear_16583_10320)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.894 16.9901L14.4966 28L11.329 19.5682L4 14.9973L11.9128 11.1738L9.40359 15.1343L13.6644 18.0238L14.9935 21.8972L17.3537 20.029L20.894 16.9901Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.894 16.9901L14.4966 28L11.329 19.5682L4 14.9973L11.9128 11.1738L9.40359 15.1343L13.6644 18.0238L14.9935 21.8972L17.3537 20.029L20.894 16.9901Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1302 14.8106L17.4531 3.99994L20.3474 12.4317L27.7137 17.1769L19.8381 21.1001L22.5088 17.0773L18.1487 14.3622L16.7326 10.3393L13.7016 12.9797L11.1302 14.8106Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1302 14.8106L17.4531 3.99994L20.3474 12.4317L27.7137 17.1769L19.8381 21.1001L22.5088 17.0773L18.1487 14.3622L16.7326 10.3393L13.7016 12.9797L11.1302 14.8106Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16583_10320",
    x1: 30.9655,
    y1: 29.3715,
    x2: 3.03239,
    y2: 7.67279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BABA6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGymPlaceholder);
export default __webpack_public_path__ + "static/media/gymPlaceholder.63cb9f470c9c7df483f0eba89c44e994.svg";
export { ForwardRef as ReactComponent };